// extracted by mini-css-extract-plugin
export var backgroundContainer = "Background-module--backgroundContainer--2yra8";
export var stars1 = "Background-module--stars1--7tvNK";
export var starAnimation = "Background-module--starAnimation--2m-0y";
export var stars2 = "Background-module--stars2--3eUrX";
export var stars3 = "Background-module--stars3--1r_Ok";